/* istanbul ignore file */
import React from 'react';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import { mapObject, constant, isFunction } from 'underscore';
import { withTheme } from 'react-jss';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { withDelayedStyles } from '@bingads-webui-campaign-react/common-utils';
import CampaignCreateAdvancedView from '@bingads-webui-campaign-legacy/campaign-create-advanced/view/index';
import { getSearchCreationStyle } from '../styles/campaign-creation-search-styles';
import { InjectWrapperWithHoC, withCreationHeader } from '../helper';
import VerticalTemplate from '../template/legacy-steps-template.pug';

function callbackAfterInjected(view) {
  if (view && isFunction(view.on)) {
    view.on('begin:switch', view.onSwitch);
    view.on('end:switch', view.onSwitched);
  }
}

const getDelayedCreationStyles = () => (
  import(/* webpackMode: 'eager' */'../styles')
    .then(({ getEntityCreationStyle }) => ({
      getDelayedStyles: getEntityCreationStyle,
    }))
);

function CampaignCreationSearch(props) {
  const {
    serverContext: {
      CurrentAccount: {
        CurrencyCode,
      },
    },
    perfMarker,
  } = props;
  return (
    <InjectWrapperWithHoC
      {...props}
      InjectViewFactory={() => Promise.resolve(CampaignCreateAdvancedView)}
      InjectViewOption={props.adExtensionsDynamicFeaturesLoader({
        permissions: props.permissions,
        theme: props.theme,
        scope: props.scope,
        instrumentation: props.instrumentation,
        i18n: props.i18n,
      })
        .then(adExtensionsDynamicFeatures => ({
          accountCurrencyCode: CurrencyCode,
          perfMarker,
          template: VerticalTemplate,
          usePanel: true,
          isForVNext: true,
          adExtensionsDynamicFeatures,
          serverContext: props.serverContext,
          scope: props.scope,
        }))}
      styleScopeName="CampaignCreationSearch"
      callbackAfterInjected={callbackAfterInjected}
    />);
}

CampaignCreationSearch.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      CurrencyCode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,

  classes: PropTypes.shape(mapObject(
    getSearchCreationStyle({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,

  perfMarker: perfMarkerPropTypes.isRequired,

  permissions: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      cid: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  instrumentation: PropTypes.shape({}).isRequired,
  adExtensionsDynamicFeaturesLoader: PropTypes.func.isRequired,
};

export const StyledCampaignCreationSearch =
  withDelayedStyles(withCreationHeader(withTheme(CampaignCreationSearch)), getSearchCreationStyle, getDelayedCreationStyles, 'shared_budget_grid_loaded');
